import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EligibleForQsbContent} from './EligibleForQsbContent';
import reportPayload from './reportPayload';

export const EligibleForQsbReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Eligible for Quick Start Bonus')}
      description={tt(
        'description',
        'These new coaches still have time to earn their QSB. Help them get there!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EligibleForQsbContent}
    />
  );
};

export const EligibleForQsbConnected = withHOC(
  withTranslation('report.eligibleForQsbReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB,
    popoverContentProps: {},
  }),
)(EligibleForQsbReport);
